import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import format from 'format-number'
import { Button } from '@mui/material';

const columns = [
  { id: 'indice', label: '', width: 15, align: 'center' },
  { id: 'fecha', label: 'Fecha', width: 150, align: 'center' },
  { id: 'documentos', label: 'Documentos', width: 150, align: 'center' },
  { id: 'monto', label: 'Monto', width: 150, align: 'right' },
];



export default function ComprobantesViaticosListado(props) {
  const { facturas, setFacturas } = props
  let total = Number(0)
  const handleDelete = async (registro) => {
    setFacturas(facturas.filter(facturas => facturas.indice !== registro.indice))
  }
  const colocarNombre = (ruta) => {
    if (!ruta || ruta === '')
      return ''
    const indice = Number(ruta.indexOf("factura")) + 9
    return ruta.slice(indice)

  }

  const mostrarDocumento = async (value, tipo) => {
    //console.log(`value en desplegarDocumentoPDF ${value}`)
    await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/servicios/mostrarFactura`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": sessionStorage.getItem('token'),
        "perfil": sessionStorage.getItem('perfil'),
        "ruta": value,
        "tipo": tipo
      }
    }
    ).then((res) => res.blob())
      .then((blob) => { // RETRIEVE THE BLOB AND CREATE LOCAL URL
        var _url = window.URL.createObjectURL(blob);
        window.open(_url, "_blank").focus(); // window.open + focus
      }).catch((err) => {
        console.error(err);
      });
  }
  return (
    <Paper sx={{ width: '100%', marginTop: 5 }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow key='encabezado'>
              <TableCell key='ninguna' align="center" colSpan={5}>
                Comprobantes para registrar
              </TableCell>
            </TableRow>
            <TableRow key='encabezado2'>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ top: 57, minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>

              ))}
              <TableCell style={{ top: 57 }}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              facturas && facturas.length > 0 ? facturas
                .map((row, index) => {
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={row.indice}>
                      {
                        columns.map((column) => {
                          const value = row[column.id];
                          
                          if (column.id === 'monto')
                            total = Number(total) + Number(value)
                          // console.log(`column.id ${column.id} row[column.id] ${row[column.id]}`)                    
                          return (
                            <TableCell key={column.id} align={column.align} style={{ whiteSpace: 'pre' }}>
                              {column.id === 'fecha' ? (value ? (new Date(value)).toLocaleString('es-MX', { day: "2-digit", month: "short", year: "numeric" }) : '') : (column.id === 'monto' ? format({ prefix: '$' })(value) :
                                column.id === 'documentos' ? <><>{value.get('PDF') ? value.get('PDF').name : <Button size='small' variant='text' style={{ marginTop: 20, textTransform: 'none' }}
                                  onClick={async () => { await mostrarDocumento(row.rutaPDF, 'pdf') }}>{colocarNombre(row.rutaPDF)}
                                </Button>}</> <><br/>{value.get('XML') ? value.get('XML').name : (row.rutaXML ? <Button size='small' variant='text' style={{ marginTop: 20, textTransform: 'none' }}
                                  onClick={async () => { await mostrarDocumento(row.rutaXML, 'xml') }}>{colocarNombre(row.rutaXML)}
                                </Button> : '')}</></> : index + 1)}
                            </TableCell>
                          );
                        })}
                      <TableCell><Button variant='contained' style={{ marginLeft: 5, backgroundColor: "darkred", color: 'white' }} onClick={() => handleDelete(row)}>{'Eliminar'}</Button></TableCell>
                    </TableRow>
                  );
                }) : <TableRow hover role="checkbox" tabIndex={-1} >

                <TableCell align='center'>
                  No hay comprobantes registrados
                </TableCell>

              </TableRow>}
            {facturas && facturas.length > 0 ? <TableRow hover role="checkbox" tabIndex={-1} >

              <TableCell align='center' colSpan={3}>

              </TableCell>
              <TableCell align='right'>
                <strong>Total: {format({ prefix: '$' })(total)}</strong>
              </TableCell>

            </TableRow> : <></>}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}